import { esc } from '../utils/formatters';

// The shared header, selection badge and disclosure used by every layer group.
export function createLayerGroupControl(group, documentRef = document) {
    const root = documentRef.createElement('div');
    root.className = 'nm-layer-group';
    root.setAttribute('data-layer-group', group.key);
    const trigger = documentRef.createElement('button');
    trigger.type = 'button';
    trigger.className = 'nm-layer-group-trigger';
    trigger.innerHTML = group.svgHtml
        + '<span class="nm-layer-group-trigger__text"><strong>' + esc(group.label) + '</strong><small>' + esc(group.description) + '</small></span>';
    const count = createLayerGroupCount(documentRef);
    trigger.appendChild(count);
    const chevron = documentRef.createElement('span');
    chevron.className = 'nm-layer-group-chevron';
    chevron.setAttribute('aria-hidden', 'true');
    chevron.textContent = '⌄';
    trigger.appendChild(chevron);
    const content = documentRef.createElement('div');
    content.className = 'nm-layer-group-content';
    content.id = 'nm-layer-group-content-' + group.key;
    trigger.setAttribute('aria-controls', content.id);
    root.append(trigger, content);
    const control = { root, trigger, count, content, label: group.label };
    syncLayerGroupControl(control, { opened: false, selectedCount: 0 });
    return control;
}

export function createLayerGroupCount(documentRef = document) {
    const count = documentRef.createElement('span');
    count.className = 'nm-layer-group-count';
    count.setAttribute('data-layer-group-count', '');
    return count;
}

export function syncLayerGroupControl(control, { opened, selectedCount, locked = false, sublayers = false }) {
    control.root.classList.toggle('is-open', opened);
    control.root.classList.toggle('has-active-layers', selectedCount > 0);
    control.trigger.classList.toggle('is-active', opened);
    control.trigger.setAttribute('aria-expanded', String(!!opened));
    control.trigger.setAttribute('aria-disabled', String(!!locked));
    control.trigger.setAttribute('aria-label', locked
        ? 'Odznacz podwarstwę, aby móc zwinąć: ' + control.label
        : (opened ? 'Ukryj ' : 'Pokaż ') + (sublayers ? 'podwarstwy: ' : 'warstwy: ') + control.label);
    control.count.textContent = selectedCount ? String(selectedCount) : '';
    control.count.classList.toggle('is-visible', selectedCount > 0);
    control.count.setAttribute('aria-label', 'Wybrane warstwy: ' + selectedCount);
}
